import { useState } from 'react';

import { MuiIcon } from 'components/common/muiIcon/muiIcon';

import { CustomizedRoundIcon, CustomizedTooltip } from 'components/common';
import { UploadRisksModal } from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/UploadRisksModal';

export const UploadRisksButton = () => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <CustomizedTooltip
                tooltipContent={'Upload Risks'}
                triggerElement={
                    <CustomizedRoundIcon onClick={() => setShowModal(true)}>
                        <MuiIcon icon={'upload'} fontSize={'2.2rem'} />
                    </CustomizedRoundIcon>
                }
            />
            <UploadRisksModal isShowModal={showModal} handleModalClose={() => setShowModal(false)} />
        </>
    );
};
